export const bussinessCategories = [
  {
    id: '120',
    name: '百货',
    children: [
      {
        id: '120006',
        name: '家居/家装',
      },
      {
        id: '120011',
        name: '家用电器',
      },
      {
        id: '120013',
        name: '烟草/电子烟/酒类',
      },
      {
        id: '120015',
        name: '批发',
      },
      {
        id: '120017',
        name: '黄金珠宝/玉石',
      },
      {
        id: '120018',
        name: '其他零售',
      },
      {
        id: '120019',
        name: '大型连锁店',
      },
      {
        id: '120020',
        name: '小型零售店',
      },
    ],
  },
  {
    id: '121',
    name: '保险',
    children: [
      {
        id: '121001',
        name: '保险公司',
      },
      {
        id: '121002',
        name: '保险经济公司',
      },
      {
        id: '121003',
        name: '保险公估公司',
      },
      {
        id: '121004',
        name: '保险代理公司',
      },
      {
        id: '121005',
        name: '其他',
      },
    ],
  },
  {
    id: '122',
    name: '电商',
    children: [
      {
        id: '122001',
        name: '社交电商/团购电商',
      },
      {
        id: '122002',
        name: '综合电商',
      },
      {
        id: '122003',
        name: '持牌直销电商',
      },
      {
        id: '122004',
        name: '直销代理电商',
      },
      {
        id: '122007',
        name: 'B2B电商',
      },
      {
        id: '122008',
        name: 'O2O电商',
      },
      {
        id: '122009',
        name: '分销电商',
      },
      {
        id: '122010',
        name: '跨境电商',
      },
      {
        id: '122011',
        name: '盲盒类电商',
      },
      {
        id: '122012',
        name: '直播电商',
      },
    ],
  },
  {
    id: '123',
    name: '公益',
    children: [
      {
        id: '123001',
        name: '公益',
      },
    ],
  },
  {
    id: '124',
    name: '航旅',
    children: [
      {
        id: '124001',
        name: '火车票/车票等长途交通票务',
      },
      {
        id: '124002',
        name: '旅行社',
      },
      {
        id: '124003',
        name: 'OTA（在线机票/旅游预订网站/线上订房中心）',
      },
      {
        id: '124004',
        name: '机票分销平台',
      },
      {
        id: '124005',
        name: '航空公司',
      },
      {
        id: '124006',
        name: '机票代理',
      },
      {
        id: '124007',
        name: '航（旅）意险销售平台',
      },
      {
        id: '124011',
        name: '酒店/旅馆/度假村/客栈民宿',
      },
      {
        id: '124015',
        name: 'TMC',
      },
      {
        id: '124016',
        name: '周边游',
      },
      {
        id: '124017',
        name: '机场贵宾厅服务',
      },
      {
        id: '124018',
        name: '旅游服务平台',
      },
    ],
  },
  {
    id: '125',
    name: '交通运输',
    children: [
      {
        id: '125001',
        name: '物流/快递',
      },
      {
        id: '125005',
        name: '其他',
      },
      {
        id: '125014',
        name: '网络货运平台',
      },
      {
        id: '125016',
        name: '公路货物运输',
      },
      {
        id: '125017',
        name: '海运货物运输',
      },
      {
        id: '125018',
        name: '航空货物运输',
      },
      {
        id: '125019',
        name: '铁路货物运输',
      },
      {
        id: '125020',
        name: '国际物流',
      },
    ],
  },
  {
    id: '126',
    name: '教育培训',
    children: [
      {
        id: '126003',
        name: '培训机构/在线教育',
      },
      {
        id: '126007',
        name: '成人教育',
      },
      {
        id: '126008',
        name: '留学机构',
      },
    ],
  },
  {
    id: '127',
    name: '金融',
    children: [
      {
        id: '127002',
        name: '助贷平台',
      },
      {
        id: '127003',
        name: '保理公司',
      },
      {
        id: '127004',
        name: '融资租赁',
      },
      {
        id: '127010',
        name: '银行',
      },
      {
        id: '127012',
        name: '消费金融',
      },
      {
        id: '127014',
        name: '基金公司/信托公司',
      },
      {
        id: '127018',
        name: '交易所',
      },
      {
        id: '127019',
        name: '典当',
      },
      {
        id: '127020',
        name: '其他金融类',
      },
      {
        id: '127024',
        name: '消费贷',
      },
      {
        id: '127025',
        name: '小贷/网贷',
      },
      {
        id: '127026',
        name: '会员权益',
      },
      {
        id: '127027',
        name: '逃废债',
      },
      {
        id: '127028',
        name: '车抵房抵',
      },
      {
        id: '127029',
        name: '供应链金融',
      },
      {
        id: '127030',
        name: '融资担保',
      },
    ],
  },
  {
    id: '128',
    name: '其他行业',
    children: [
      {
        id: '128001',
        name: '其他',
      },
    ],
  },
  {
    id: '129',
    name: '商业服务',
    children: [
      {
        id: '129009',
        name: '人才中介机构/招聘/猎头',
      },
      {
        id: '129011',
        name: '法律咨询/金融咨询等（医疗咨询除外）',
      },
      {
        id: '129012',
        name: '广告投放/会展/活动策划',
      },
      {
        id: '129013',
        name: '招投标行业',
      },
      {
        id: '129015',
        name: '建站/技术开发/软件开发',
      },
    ],
  },
  {
    id: '132',
    name: '休闲娱乐',
    children: [
      {
        id: '132002',
        name: '院线影城/演出/赛事',
      },
      {
        id: '132007',
        name: '其他',
      },
      {
        id: '132008',
        name: '短剧内容平台',
      },
      {
        id: '132009',
        name: '短剧投流平台',
      },
      {
        id: '132010',
        name: '网络小说/在线图书',
      },
      {
        id: '132011',
        name: '游戏周边服务/交易平台',
      },
      {
        id: '132012',
        name: '彩票',
      },
      {
        id: '132013',
        name: '网络直播',
      },
      {
        id: '132014',
        name: '游戏',
      },
    ],
  },
  {
    id: '133',
    name: '泛医美/医疗服务/大健康',
    children: [
      {
        id: '133002',
        name: '医药平台/医药批发',
      },
      {
        id: '133003',
        name: '医疗咨询/挂号服务/心理咨询',
      },
      {
        id: '133004',
        name: '医疗器械',
      },
      {
        id: '133005',
        name: '私立医院',
      },
      {
        id: '133006',
        name: '公立医院',
      },
      {
        id: '133008',
        name: '其他大健康/泛医美',
      },
      {
        id: '133009',
        name: '体检机构',
      },
      {
        id: '133010',
        name: '线下连锁药店',
      },
      {
        id: '133011',
        name: '养老照护服务',
      },
      {
        id: '133012',
        name: '医疗美容（整容整形）',
      },
      {
        id: '133013',
        name: '生活美容',
      },
      {
        id: '133014',
        name: '营养品/保健品',
      },
    ],
  },
  {
    id: '135',
    name: '数字藏品',
    children: [
      {
        id: '135001',
        name: '发行商',
      },
      {
        id: '135002',
        name: '交易平台',
      },
      {
        id: '135003',
        name: '综合平台',
      },
      {
        id: '135004',
        name: 'IP版权合作方',
      },
      {
        id: '135005',
        name: '数据要素',
      },
      {
        id: '135006',
        name: '数字资产',
      },
      {
        id: '135007',
        name: 'Web3应用',
      },
    ],
  },
  {
    id: '136',
    name: '能源',
    children: [
      {
        id: '136004',
        name: '4S店/直营连锁',
      },
      {
        id: '136005',
        name: '二手车销售',
      },
      {
        id: '136006',
        name: '停车服务',
      },
      {
        id: '136007',
        name: '汽车洗美/维护养护',
      },
      {
        id: '136009',
        name: '加油站/加气站/充电桩',
      },
      {
        id: '136010',
        name: '其他',
      },
      {
        id: '136011',
        name: '加油卡/加油服务',
      },
    ],
  },
  {
    id: '137',
    name: '政务',
    children: [
      {
        id: '137001',
        name: '民办学校/私立学校',
      },
      {
        id: '137002',
        name: '事业单位/政府机构',
      },
      {
        id: '137003',
        name: '公立院校',
      },
      {
        id: '137004',
        name: '协会性质社会团体与行业协会',
      },
      {
        id: '137005',
        name: '其他',
      },
    ],
  },
  {
    id: '138',
    name: '元宇宙',
    children: [
      {
        id: '138001',
        name: '数字权益行业（NaaS）',
      },
      {
        id: '138002',
        name: '数字藏品',
      },
      {
        id: '138003',
        name: '元宇宙营销',
      },
      {
        id: '138004',
        name: '短剧营销',
      },
      {
        id: '138005',
        name: '数字文旅',
      },
    ],
  },
  {
    id: '139',
    name: '房地产服务',
    children: [
      {
        id: '139001',
        name: '房地产服务',
      },
      {
        id: '139002',
        name: '物业管理',
      },
      {
        id: '139003',
        name: '地产/房屋中介代理',
      },
    ],
  },
  {
    id: '140',
    name: '出行服务',
    children: [
      {
        id: '140001',
        name: '出租车/网约车',
      },
      {
        id: '140002',
        name: '共享交通出行',
      },
      {
        id: '140003',
        name: '接送机',
      },
      {
        id: '140004',
        name: '其他',
      },
      {
        id: '140005',
        name: '租车服务',
      },
      {
        id: '140006',
        name: '代驾',
      },
    ],
  },
  {
    id: '141',
    name: '本地生活',
    children: [
      {
        id: '141001',
        name: '交通罚款等生活缴费',
      },
      {
        id: '141002',
        name: '酒吧/休闲会所/KTV/Livehouse',
      },
      {
        id: '141003',
        name: '体育馆/健身房',
      },
      {
        id: '141004',
        name: '洗浴/保健养生服务',
      },
      {
        id: '141005',
        name: '餐饮',
      },
      {
        id: '141006',
        name: '水电煤燃气缴费',
      },
      {
        id: '141007',
        name: '手机充值/有线电视缴费',
      },
      {
        id: '141008',
        name: '社区服务/便民服务/家政服务',
      },
      {
        id: '141009',
        name: '出版社/出版公司',
      },
    ],
  },
  {
    id: '142',
    name: '实物租赁',
    children: [
      {
        id: '142001',
        name: '3C租赁',
      },
      {
        id: '142002',
        name: '奢侈品/古董租赁',
      },
      {
        id: '142003',
        name: '手机租赁',
      },
    ],
  },
  {
    id: '143',
    name: '外贸进口',
    children: [
      {
        id: '143001',
        name: '车辆、机械设备及零件',
      },
      {
        id: '143002',
        name: '医药及医疗器械',
      },
      {
        id: '143003',
        name: '化工产品和塑料制品，及其原材料',
      },
      {
        id: '143004',
        name: '电子产业（如电子元器件）',
      },
      {
        id: '143005',
        name: '数码家电、家具灯具',
      },
      {
        id: '143006',
        name: '纺织品及服装',
      },
      {
        id: '143007',
        name: '食品及饮料',
      },
      {
        id: '143008',
        name: '日用/家用/办公用品、工艺制品',
      },
      {
        id: '143009',
        name: '金属，及其原材料',
      },
      {
        id: '143010',
        name: '矿产和能源产品',
      },
      {
        id: '143099',
        name: '其他',
      },
    ],
  },
  {
    id: '144',
    name: '外贸出口',
    children: [
      {
        id: '144001',
        name: '车辆、机械设备及零件',
      },
      {
        id: '144002',
        name: '医药及医疗器械',
      },
      {
        id: '144003',
        name: '化工产品和塑料制品，及其原材料',
      },
      {
        id: '144004',
        name: '电子产业（如电子元器件）',
      },
      {
        id: '144005',
        name: '数码家电、家具灯具',
      },
      {
        id: '144006',
        name: '纺织品及服装',
      },
      {
        id: '144007',
        name: '食品及饮料',
      },
      {
        id: '144008',
        name: '日用/家用/办公用品、工艺制品',
      },
      {
        id: '144009',
        name: '金属，及其原材料',
      },
      {
        id: '144010',
        name: '矿产和能源产品',
      },
      {
        id: '144099',
        name: '其他',
      },
    ],
  },
  {
    id: '145',
    name: '跨境进口电商',
    children: [
      {
        id: '145001',
        name: '车辆、机械设备及零件',
      },
      {
        id: '145002',
        name: '医药及医疗器械',
      },
      {
        id: '145003',
        name: '化工产品和塑料制品，及其原材料',
      },
      {
        id: '145004',
        name: '电子产业（如电子元器件）',
      },
      {
        id: '145005',
        name: '数码家电、家具灯具',
      },
      {
        id: '145006',
        name: '纺织品及服装',
      },
      {
        id: '145007',
        name: '食品及饮料',
      },
      {
        id: '145008',
        name: '日用/家用/办公用品、工艺制品',
      },
      {
        id: '145009',
        name: '金属，及其原材料',
      },
      {
        id: '145010',
        name: '矿产和能源产品',
      },
      {
        id: '145099',
        name: '其他',
      },
    ],
  },
  {
    id: '146',
    name: '跨境出口电商',
    children: [
      {
        id: '146001',
        name: '车辆、机械设备及零件',
      },
      {
        id: '146002',
        name: '医药及医疗器械',
      },
      {
        id: '146003',
        name: '化工产品和塑料制品，及其原材料',
      },
      {
        id: '146004',
        name: '电子产业（如电子元器件）',
      },
      {
        id: '146005',
        name: '数码家电、家具灯具',
      },
      {
        id: '146006',
        name: '纺织品及服装',
      },
      {
        id: '146007',
        name: '食品及饮料',
      },
      {
        id: '146008',
        name: '日用/家用/办公用品、工艺制品',
      },
      {
        id: '146009',
        name: '金属，及其原材料',
      },
      {
        id: '146010',
        name: '矿产和能源产品',
      },
      {
        id: '146099',
        name: '其他',
      },
    ],
  },
  {
    id: '147',
    name: '服贸进口',
    children: [
      {
        id: '147001',
        name: '航空机票',
      },
      {
        id: '147002',
        name: '酒店住宿',
      },
      {
        id: '147003',
        name: '旅游服务',
      },
      {
        id: '147004',
        name: '国际运输',
      },
      {
        id: '147005',
        name: '游戏直播',
      },
      {
        id: '147006',
        name: '软件服务（游戏直播以外的其他应用）',
      },
      {
        id: '147007',
        name: '留学教育',
      },
      {
        id: '147008',
        name: '广告业务',
      },
      {
        id: '147009',
        name: '其他',
      },
    ],
  },
  {
    id: '148',
    name: '服贸出口',
    children: [
      {
        id: '148001',
        name: '航空机票',
      },
      {
        id: '148002',
        name: '酒店住宿',
      },
      {
        id: '148003',
        name: '旅游服务',
      },
      {
        id: '148004',
        name: '国际运输',
      },
      {
        id: '148005',
        name: '游戏直播',
      },
      {
        id: '148006',
        name: '软件服务（游戏直播以外的其他应用）',
      },
      {
        id: '148007',
        name: '留学教育',
      },
      {
        id: '148008',
        name: '广告业务',
      },
      {
        id: '148009',
        name: '其他',
      },
    ],
  },
  {
    id: '149',
    name: '海外支付机构（PSP）',
    children: [
      {
        id: '149001',
        name: '货贸',
      },
      {
        id: '149002',
        name: '服贸',
      },
      {
        id: '149003',
        name: '货贸&服贸',
      },
      {
        id: '149004',
        name: '薪酬赡家',
      },
    ],
  },
  {
    id: '150',
    name: '薪酬赡家',
    children: [
      {
        id: '150001',
        name: '薪酬赡家款汇入',
      },
    ],
  },
];
